// extracted by mini-css-extract-plugin
module.exports = {"headerContainer":"Header_headerContainer__1EGv3","addWidgetButton":"Header_addWidgetButton__24yOf","dashboardTabs":"Header_dashboardTabs__wns0y","active":"Header_active__2q8gV"};